import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Paths from "routes/Paths";

import styles from "./NotFoundPage.module.css";

const NotFoundPage = () => {
	const { t } = useTranslation("common");

	return (
		<main className={styles.root}>
			<section className={styles.panel}>
				<h1>{t("notFound.title")}</h1>
				<Link to={Paths.signIn}>{t("notFound.backToSignIn")}</Link>
			</section>
		</main>
	);
};

export default NotFoundPage;
